import ConnectedSampleText from './Container';

export default ConnectedSampleText;
